import Vue from 'vue'
import Router from 'vue-router'
import Rating from 'components/Rating'
import ListBeers from 'components/ListBeers'
import AddNew from 'components/AddNew'

Vue.use(Router)

export default new Router({
  // Removes hash tag from url
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Rating',
      component: Rating
    },
    {
      path: '/list-beers',
      name: 'ListBeers',
      component: ListBeers
    },
    {
      path: '/add-new',
      name: 'AddNew',
      component: AddNew
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js